import { html, rune, View } from 'rune-ts';
import { typoPcMo } from '../../../../shared/typography/typo';
import klass from './Input.module.scss';
import { InputProps, InputType } from './type';
import { isNil } from '@fxts/core';

export class Input extends View<InputProps> {
  type: InputType = 'text';
  value: number | string;

  constructor(data: InputProps) {
    super(data);
    this.type = data.type ?? this.type;
    this.value = data.value ?? '';
  }

  protected override template() {
    const {
      placeholder,
      name,
      maxlength,
      readonly,
      required,
      autofocus,
      disabled,
      is_mobile,
      autocomplete,
      min,
      max,
      step,
      inputmode,
    } = this.data;

    return html` <input
      class="${klass.input} ${typoPcMo({
        is_mobile: is_mobile ?? rune.getSharedData(this)?.is_mobile,
        pc: '16_medium',
        mo: '14_medium',
      })}"
      type="${this.type}"
      placeholder="${placeholder ?? ''}"
      value="${this.value}"
      name="${name}"
      ${maxlength && maxlength > 0 ? `maxlength=${maxlength}` : ''}
      ${required ? 'required' : ''}
      ${autofocus ? 'autofocus' : ''}
      ${disabled ? 'disabled' : ''}
      ${readonly ? 'readonly' : ''}
      ${autocomplete ? 'autocomplete' : ''}
      ${step ? `step=${step}` : ''}
      ${!isNil(min) ? `min=${min}` : ''}
      ${!isNil(max) ? `max=${max}` : ''}
      data-readonly="${!!readonly}"
      ${inputmode ? `inputmode=${inputmode}` : ''}
    />`;
  }

  override redraw(): this {
    const input = this.element() as HTMLInputElement;
    const { placeholder, readonly, disabled, required, autofocus } = this.data;

    input.placeholder = placeholder ?? '';
    input.type = this.type;
    input.value = this.value.toString();
    input.disabled = !!(readonly || disabled);
    input.required = !!required;
    input.autofocus = !!autofocus;
    input.dataset.readonly = (!!readonly).toString();

    return this;
  }

  reset() {
    const input = this.element() as HTMLInputElement;
    input.value = '';
    this.value = input.value;
  }

  setValue(value: number | string) {
    const input = this.element() as HTMLInputElement;
    input.value = value.toString();
    this.value = input.value;
  }

  getValue() {
    const input = this.element() as HTMLInputElement;
    this.value = input.value;
    return input.value;
  }
}
